<template>
  <a-spin :spinning="confirmLoading">

    <a-tabs defaultActiveKey="1" type="card" @tabClick="onTabClick">
      <a-tab-pane tab="当前版本" key="1">
        <j-form-container :disabled="formDisabled">
          <a-form :form="form" slot="detail">
            <a-row>
              <a-col :span="24" v-if="isShowProjNum">
                <a-form-item label="项目编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['projNum', {}]" disabled/>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="项目组" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-decorator="['projectGroup', validatorRules.projectGroup]"
                                     :trigger-change="true" dictCode="bms_project" placeholder="请选择项目组" :disabled="itemDisabled"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="二级单位" :labelCol="labelCol" :wrapperCol="wrapperCol" :help="subSegmentHelp">
                  <j-dict-select-tag type="list" v-decorator="['subSegment', validatorRules.subSegment]"
                                     :trigger-change="true" dictCode="bms_sub_segment" placeholder="请选择二级单位" :disabled="itemDisabled"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入项目名称"
                           :disabled="itemDisabled"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="项目简称" :labelCol="labelCol" :wrapperCol="wrapperCol"
                >
                  <a-input v-decorator="['shortName', validatorRules.shortName]" placeholder="请输入项目简称"
                           :disabled="itemDisabled"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="英文简写" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['shortNameEn', validatorRules.shortNameEn]" placeholder="请输入英文简写"
                           :disabled="itemDisabled"></a-input>
                </a-form-item>
              </a-col>

              <a-col :span="24" v-if="isShowCustomerDict">
                <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-search-select-tag v-decorator="['customer',{}]" dict="biz_customer,name,id" :async="true" disabled> </j-search-select-tag>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-else>
                <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input
                    placeholder="请输入客户名称"
                    v-decorator="['customer', validatorRules.customer]">
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="项目类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-decorator="['type', validatorRules.type]"
                                     :trigger-change="true" dictCode="bms_project_type" placeholder="请选择项目类型" disabled/>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="客户来源渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-decorator="['customerSourceType', validatorRules.customerSourceType]"
                                     :trigger-change="true" dictCode="bms_customer_source_type" placeholder="请选择客户来源渠道" :disabled="itemDisabled"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位性质" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-decorator="['customerType',validatorRules.customerType]"
                                     :trigger-change="true" dictCode="bms_customer_type" placeholder="请选择单位性质"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位注册地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['customerRegisterAddress',validatorRules.customerRegisterAddress]" placeholder="请输入单位注册地址"/>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="预估保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input-number :max="9999999999" v-decorator="['customerCostBudget',validatorRules.customerCostBudget]"
                                  placeholder="请输入预估保费支出额度" style="width:100%;"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="资产/工程投资" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入企业资产分布情况、资产价值、固定资产、厂房、设备、存货、营收情况等;如有投资或关联的工程项目，请描述项目整体情况，包括工期、造价等">
                    <a-textarea :autoSize="true" v-decorator="['customerAssets',validatorRules.customerAssets]"
                                placeholder="请输入企业资产分布情况、资产价值、固定资产、厂房、设备、存货、营收情况等;如有投资或关联的工程项目，请描述项目整体情况，包括工期、造价等"/>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入单位人数、年龄结构、男女比例、婚否比例、是否购买员工福利保障等">
                    <a-textarea :autoSize="true" v-decorator="['customerPeople',validatorRules.customerPeople]"
                                placeholder="请输入单位人数、年龄结构、男女比例、婚否比例、是否购买员工福利保障等"/>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位车辆" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入单位自有车辆数量、车辆类型、购买险种、保额、保险公司等">
                    <a-textarea :autoSize="true" v-decorator="['customerCar',validatorRules.customerCar]"
                                placeholder="请输入单位自有车辆数量、车辆类型、购买险种、保额、保险公司等"/>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位其他情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入包括但不限于单位所处行业类型、地理位置，所在行业的市场份额占比、排名、主营业务收入等">
                    <a-textarea :autoSize="true" v-decorator="['customerOther',validatorRules.customerOther]"
                                placeholder="请输入包括但不限于单位所处行业类型、地理位置，所在行业的市场份额占比、排名、主营业务收入等"/>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="近三年购买/索赔" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="近三年公司购买保险情况（包括保单、保险方案等）、保险索赔情况、赔付时效等">
                    <a-textarea :autoSize="true" v-decorator="['purchasesRecentThreeYears',validatorRules.purchasesRecentThreeYears]"
                                placeholder="近三年公司购买保险情况（包括保单、保险方案等）、保险索赔情况、赔付时效等"/>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="项目进展" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入项目沟通的进展程度，获取的相关信息等">
                    <a-textarea :autoSize="true" v-decorator="['progress',validatorRules.progress]"
                                placeholder="请输入项目沟通的进展程度，获取的相关信息等"/>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-decorator="['file']" :trigger-change="true" :disabled="disabled" bizPath="project-info"/>
                </a-form-item>
              </a-col>

              <a-col :span="24" v-if="isShowAuditRemark"> <!--审核未通过时显示原因-->
                <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea :autoSize="true" v-decorator="['auditRemark',{}]" disabled/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </j-form-container>
      </a-tab-pane>

      <a-tab-pane v-for="version in tabs" :tab="version" :key="version" v-if="isRenewalProject">
        <j-form-container  disabled>
          <a-form>
            <a-row>
              <a-col :span="24" v-if="isShowProjNum">
                <a-form-item label="项目编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.projNum" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="项目组" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-model="tabModel.projectGroup"
                                     :trigger-change="true" dictCode="bms_project" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="二级单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-model="tabModel.subSegment"
                                     :trigger-change="true" dictCode="bms_sub_segment" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.name" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="项目简称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.shortName" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="英文简写" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.shortNameEn" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="isShowCustomerDict">
                <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-search-select-tag v-model="tabModel.customer" dict="biz_customer,name,id" :async="true" disabled> </j-search-select-tag>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-else>
                <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.customer" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="项目类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-model="tabModel.type"
                                     :trigger-change="true" dictCode="bms_project_type" disabled/>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="客户来源渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-model="tabModel.customerSourceType"
                                     :trigger-change="true" dictCode="bms_customer_source_type" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位性质" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-model="tabModel.customerType"
                                     :trigger-change="true" dictCode="bms_customer_type" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位注册地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.customerRegisterAddress" disabled/>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="预估保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input-number :max="9999999999" v-model="tabModel.customerCostBudget" style="width:100%;" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="资产/工程投资" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="企业资产分布情况、资产价值、固定资产、厂房、设备、存货、营收情况等;如有投资或关联的工程项目，请描述项目整体情况，包括工期、造价等">
                    <a-textarea :autoSize="true" v-model="tabModel.customerAssets" disabled/>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入单位人数、年龄结构、男女比例、婚否比例、是否购买员工福利保障等">
                    <a-textarea :autoSize="true" v-model="tabModel.customerPeople" disabled/>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位车辆" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="单位自有车辆数量、车辆类型、购买险种、保额、保险公司等">
                    <a-textarea :autoSize="true" v-model="tabModel.customerCar" disabled/>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="单位其他情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="包括但不限于单位所处行业类型、地理位置，所在行业的市场份额占比、排名、主营业务收入等">
                    <a-textarea :autoSize="true" v-model="tabModel.customerOther" disabled/>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="近三年购买/索赔" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="近三年公司购买保险情况（包括保单、保险方案等）、保险索赔情况、赔付时效等">
                    <a-textarea :autoSize="true" v-model="tabModel.purchasesRecentThreeYears" disabled/>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="项目进展" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="项目沟通的进展程度，获取的相关信息等">
                    <a-textarea :autoSize="true" v-model="tabModel.progress" disabled/>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-model="tabModel.file" :trigger-change="true" :disabled="disabled" bizPath="project-info" disabled/>
                </a-form-item>

              </a-col>
              <a-col :span="24" v-if="isShowAuditRemark">
                <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea :autoSize="true" v-model="tabModel.auditRemark" disabled/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </j-form-container>
      </a-tab-pane>
    </a-tabs>

  </a-spin>
</template>

<script>

import { httpAction, getAction, postAction } from '@/api/manage'
import pick from 'lodash.pick'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
import JEditor from '@/components/jeecg/JEditor'
import ProjectConst from '../../ProjectConst'
import ProjectStatus from '../../ProjectStatus'
import JUpload from '@/components/jeecg/JUpload'
import tabs from 'ant-design-vue/lib/tabs'

export default {
  name: 'ProjectInfoForm',
  components: {
    JFormContainer,
    JDate,
    JSearchSelectTag,
    JDictSelectTag,
    JEditor,
    JUpload,
  },
  props: {
    //表单data
    formData: {
      type: Object,
      default: ()=>{},
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      subSegmentHelp: '山能项目请填充二级单位',
      tabs: [],
      tabModel: {},
      form: this.$form.createForm(this),
      projectConst:{},
      // 操作类型 新增 编辑 续保, 默认详情
      operationType: ProjectConst.PROJECT_OPERATION_TYPE_DETAIL,
      model: {
      },
      labelCol: {


        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        name: {
          rules: [
            { required: true, message: '请输入项目名称!'},
            { max: 50, message: '项目简称长度不能超过50个字符!'},
            { whitespace: true, message:'不能为空格'},
            /*{ validator: this.checkNameExists},*/
          ]
        },
        shortName: {
          rules: [
            { required: true, message: '请输入项目简称!'},
            { max: 10, message: '项目简称长度不能超过10个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
        shortNameEn:{
          rules: [
            /* { required: true, message: '请输入英文简写!'},*/
            { max: 10, message: '英文简写长度不能超过10个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
        customer:{
          rules: [
            { required: true, message: '请输入客户名称!'},
            /* { validator: this.checkCustomerExists}*/
          ]
        },
        type: {
          rules: [
            { required: true, message: '请选择项目类型!'},
          ]
        },
        customerCostBudget: {
          rules: [
            { required: true, message: '预估保费不能为空!'}
          ]
        },
        customerSourceType:{
          rules: [
            { required: true, message: '请选择客户来源渠道!'},
          ]
        },
        projectGroup:{
          rules: [
            { required: true, message: '请选择项目组!'},
          ]
        },
        subSegment:{
        },
        customerType:{
          rules: [
            { required: true, message: '请选择客户单位性质!'},
          ]
        },
        customerRegisterAddress:{
          rules: [
            { required: true,max: 255, message: '单位注册地址长度不能超过255个字符!'},
          ]
        },
        customerAssets:{
          rules: [
            { required: true,max: 500, message: '资产/工程投资情况长度不能超过500个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
        customerPeople:{
          rules: [
            { required: true,max: 500, message: '单位人员情况长度不能超过500个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
        customerCar:{
          rules: [
            { required: true,max: 500, message: '单位车辆情况长度不能超过500个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
        customerOther:{
          rules: [
            { required: true,max: 1000, message: '单位其他情况长度不能超过1000个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
        purchasesRecentThreeYears:{
          rules: [
            { required: true,max: 500, message: '近三年购买/索赔长度不能超过500个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
        progress: {
          rules: [
            { required: true,max: 500, message: '项目进展长度不能超过500个字符!'},
            { whitespace: true, message:'不能为空格'}
          ]
        },
      },
      url: {
        add: "/project/baseInfo/add",
        edit: "/project/baseInfo/edit",
        renewal: "/project/baseInfo/renewal",
        queryById: "/project/baseInfo/queryById",
        checkCustomerExists:"/biz/customer/existsByName",
        checkNameExist:"/project/baseInfo/checkNameExist",
        hisData:"/project/baseInfo/hisData",
      }
    }
  },
  computed: {
    formDisabled(){
        return this.disabled;
    },
    itemDisabled() {
      if(this.model.renewFlag == 1) {
        return true;
      }else {
        return this.disabled;
      }
    },
    isShowProjNum(){
      if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_EDIT ||
        this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_DETAIL){
        return true
      }
      //新增、续保时不显示
      return false
    },
    isShowCustomerDict(){
      if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_EDIT ||
        this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_DETAIL ||
        this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_RENEW){
        return true
      }
      //新增时显示录入框
      return false
    },
    isShowAuditRemark(){
      if(this.model && this.model.auditRemark &&
        (this.model.status === ProjectStatus.PLAN_APPLY || this.model.status === ProjectStatus.CANCEL)){
        return true
      }
      return false
    },
    //是否续保项目, 续保项目名称不能编辑
    isRenewalProject(){
      if(this.model && this.model.renewFlag == ProjectConst.PROJECT_TYPE_RENEW){
        return true
      }
      return false
    },
    // 续保操作时，项目类型不可选
    /*isRenewalOperation(){
      if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_RENEW){
        return true
      }
      // 系统续保操作后的续保项目编辑时，项目类型不能改变, 系统新增的续保项目编辑时可以重新选择
      if(this.model.relationId != null && this.model.relationId != undefined &&
        this.model.type === ProjectConst.PROJECT_TYPE_RENEW){
        return true
      }
      return false
    },*/
  },
  created () {
    this.projectConst = ProjectConst
  },
  methods: {
    onTabClick(key) {
      if(key == 1) {return;}
      let url = this.url.hisData;
      let tempModel = this.tabModel;
      let param = {version: key,projNum: this.tabModel.projNum};
      postAction(url,param).then((res)=>{
        if(res.success){
          if(res.result){
            // tempModel['projNum'] = '测试Click'+key;
            Object.keys(res.result).forEach(key => {
              tempModel[key] = res.result[key]
            })
          } else {
            callback('未找到该项目');
          }
        }else{
          callback(res.message);
        }
      })
    },
    add () {
      this.operationType = ProjectConst.PROJECT_OPERATION_TYPE_ADD
      this.form.resetFields();
      this.model = {};
      this.model.type = ProjectConst.PROJECT_TYPE_NEW //类型为新项目
      this.model.status = ProjectStatus.PLAN_APPLY; // 未提交状态
      this.setFieldValues()
    },

    edit (record) {
      this.operationType = ProjectConst.PROJECT_OPERATION_TYPE_EDIT
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.setFieldValues();
      let vs = this.model.versions
      if(vs) {
        this.tabModel = Object.assign({}, record);
        this.tabs = vs.split(',');
      } else {
        this.tabs = []
      }
    },
    // 检查项目名称是否已存在
    checkNameExists(rule, value, callback){
      if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_EDIT ||
        this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_RENEW){
        callback() //编辑和续保时不检查
      }

      if(value === undefined || value==="" || value.trim() === ""){
        callback() // 前面有空检查
      }

      let url = this.url.checkNameExist;
      postAction(url,{name: value}).then((res)=>{
        if(res.success){
          if(res.result){
            callback("项目名称已存在"); // 存在返回true
          } else {
            callback(); // 不存在
          }
        }else{
          callback(res.message);
        }
      })
    },

    // 检查客户名称是否存在
    checkCustomerExists(rule, value, callback){
      if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_EDIT ||
        this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_RENEW){
        callback() //编辑和续保时不检查
      }

      if(value === undefined || value==="" || value.trim() === ""){
        callback() // 前面有空检查
      }

      let url = this.url.checkCustomerExists + "?customerName=" + value;
      getAction(url).then((res)=>{
        if(res.success){
          if(res.result){
            callback("客户名称已存在"); // 存在
          } else {
            callback(); // 不存在
          }
        }else{
          that.$message.warning(res.message);
        }
      })
    },
    // 续保
    renewal(record){
      let newRecord = Object.assign({}, record);
      let oldType = record.type; //原项目类型
      let projectGroup = record.projectGroup;
      let subSegment = record.subSegment;
      this.operationType = ProjectConst.PROJECT_OPERATION_TYPE_RENEW
      newRecord.relationId = newRecord.id //赋值原项目id
      newRecord.id = null
      newRecord.type = ProjectConst.PROJECT_TYPE_RENEW //类型为续保项目
      newRecord.status = ProjectStatus.RENEWAL //状态为续保中
      newRecord.projectGroup = projectGroup //续保项目项目组与原项目相同
      newRecord.subSegment = subSegment //续保项目细分与原项目相同
      // 续保项目的名字为原项目名字 + 当前年月
      let year = new Date().getFullYear()
      let month = new Date().getMonth() +1
      if(month <=9){
        month = "0" + month
      }
      if(oldType === ProjectConst.PROJECT_TYPE_NEW){// 原项目类型为新项目，第一次续保
        newRecord.name = newRecord.name + year + month
      } else { //原项目已是续保项目，去掉原年月
        newRecord.name = newRecord.name.substr(0,newRecord.name.length - 6) + year + month
      }
      newRecord.createBy = null //置空
      newRecord.createTime = null
      newRecord.updateBy = null
      newRecord.updateTime = null
      newRecord.file = null // 附件置空
      // 其他字段值不变
      this.form.resetFields();
      this.model = Object.assign({}, newRecord);
      this.setFieldValues()
    },

    setFieldValues(){
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'projNum','name','shortName','shortNameEn','customer','type','subSegment',
          'relationId', 'customerSourceType', 'customerType', 'customerRegisterAddress', 'customerAssets','projectGroup',
          'customerPeople', 'customerCar', 'customerOther', 'purchasesRecentThreeYears', 'customerCostBudget',
          'progress','auditRemark','file'))
      })
    },
    submitForm () {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        // alert(JSON.stringify(values));
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_ADD){
            httpurl+=this.url.add;
            method = 'post';
          }else if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_EDIT){
            httpurl+=this.url.edit;
            method = 'put';
          } else if(this.operationType === ProjectConst.PROJECT_OPERATION_TYPE_RENEW){
            httpurl+=this.url.renewal;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          this.trimFormData(formData);

          httpAction(httpurl,formData,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },

    trimFormData(formData){
      formData.projNum = formData.projNum ? formData.projNum.trim() : '';
      formData.name = formData.name ? formData.name.trim() : '';
      formData.shortName = formData.shortName ? formData.shortName.trim() : '';
      formData.shortNameEn = formData.shortNameEn ? formData.shortNameEn.trim() : '';
      formData.remarks = formData.remarks ? formData.remarks.trim() : '';
    },

    popupCallback(row){
      this.setFieldValues()
    },
  }
}
</script>

<style>
/**控制主体颜色*/
.draw_atooltip .ant-tooltip-inner {
  color: #ccc !important;
  background-color: #fff !important;
  min-width: 500px !important;
}
/*控制三角形颜色*/
.draw_atooltip .ant-tooltip-arrow::before {
  background-color: #fff;
}
</style>